import { apiConstantsURL } from '../../constants';
import { axiosClient } from '../../utils/axiosClient';

export const saveFeedback = async (message, rating) => {
  const response = await axiosClient.post(
    apiConstantsURL.settings.saveFeedback + message + '&rating=' + rating
  );
  return response;
};
export const saveContact = async (message) => {
  const response = await axiosClient.post(
    apiConstantsURL.settings.saveContact + message
  );
  return response;
};
